import axiosInstance from "../Middleware/interceptor";
import { toast } from "react-toastify";


export const postApi = async (url, data, config = {}) => {
  try {
    const response = await axiosInstance.post(`${url}`, data, config);
    // Don't show toast here - let the component handle success/error messages
    // if (response?.data?.statusCode === 200) {
    //   toast.success(response?.data?.message);
    // } else {
    //   toast.error(response?.data?.message);
    // }

    return response?.data;
  } catch (error) {
    // Don't show toast for errors - let the component handle it
    // This allows components to show custom error messages
    
    // if (error.response) {
    //   toast.error(`Error: ${error.response.data.message || 'An unexpected error occurred'}`);
    // } else if (error.request) {
    //   toast.error('No response from server. Please try again later.');
    // } else {
    //   toast.error(`Error: ${error.message}`);
    // }

    throw error; // Re-throw the error to propagate it further if necessary
  }
};

export const getApi = async (url,config = {}) => {
  try {
    const response = await axiosInstance.get(`${url}`,config);
    // Don't show toast here - let the component handle success/error messages
    // if(response?.data?.statusCode === 200){
    //   // toast.success(response?.data?.message)
    // } else{
    //   toast.error(response?.data?.message)
    // }
    return response?.data;
  } catch (error) {
    throw error;
  }
};

export const putApi = async (url, data, config = {}) => {
  try {
    const response = await axiosInstance.put(`${url}`, data, config);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteApi = async (url, data) => {
  try {
    const response = await axiosInstance.delete(`${url}`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

